import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import LanguageProvider from './containers/LanguageProvider';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import 'typeface-roboto'

import './index.css';

const isIOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

// Robust Android WebView detection
const isAndroidWebView = () => {
  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);

  // Common tokens that indicate WebView on Android: 'wv' or 'Version/' or missing 'Chrome/' in some old webviews.
  const hasWv = /\bwv\b/i.test(ua) || /; wv\)/i.test(ua);
  const hasVersion = /Version\//i.test(ua);
  const isChrome = /Chrome\//i.test(ua);

  // Some webviews expose a native JS bridge object (e.g. window.Android)
  const hasNativeBridge = typeof window.Android !== 'undefined' || typeof window.android !== 'undefined';

  // Log UA for debugging if devtools open (keeps helpful info during testing)
  try {
    // eslint-disable-next-line no-console
    console.log('[detect] userAgent:', ua, 'hasWv:', hasWv, 'hasVersion:', hasVersion, 'isChrome:', isChrome, 'hasNativeBridge:', !!hasNativeBridge);
  } catch (e) {}

  // Heuristic: Android + (wv token OR Version/ token OR native bridge OR likely webview chrome without explicit Chrome token)
  if (!isAndroid) return false;
  if (hasWv || hasVersion || hasNativeBridge) return true;

  // Fallback: if Android and not iOS and not a desktop-like UA
  return isAndroid && !/Windows NT|Macintosh|Linux x86_64/i.test(ua);
};

const theme = createTheme({
  typography: {
    fontFamily: [
      'Roboto',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#1890ff',
    },
    white: {
      main: '#fff',
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
  },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </ThemeProvider>,
  document.getElementById('root')
);

// Apply padding for Android WebView after render and on viewport changes
const applyAndroidPadding = () => {
  if (!isAndroidWebView() || isIOS()) return;

  const root = document.getElementById('root');
  if (!root) return;

  // Prefer to compute available overlay by comparing screen.height vs innerHeight
  let overlay = (window.screen && window.screen.height) ? (window.screen.height - window.innerHeight) : 0;

  // If overlay is small or negative, fall back to a sensible default
  if (!overlay || overlay < 20) overlay = 25;

  root.style.paddingTop = overlay + 'px';
  // eslint-disable-next-line no-console
  console.log('[applyAndroidPadding] applied', overlay + 'px');
};

// run once after render
setTimeout(applyAndroidPadding, 50);

// update when viewport changes (keyboard, orientation, etc.)
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', applyAndroidPadding);
  window.visualViewport.addEventListener('scroll', applyAndroidPadding);
}

// also listen for resize as a fallback
window.addEventListener('resize', applyAndroidPadding);